export default __webpack_public_path__ + "static/media/logo.863da5df.png";